const ACCOUNTS_TYPES = {
  1: "linkedin",
  2: "github",
  3: "behance",
  4: "dribbble",
  5: "website",
};

export default ACCOUNTS_TYPES;
